export default __webpack_public_path__ + "static/media/baju2.685e8792.webp";